import { css } from 'styled-components'

export default ({ disabled }) =>
  disabled &&
  css`
    opacity: 0.5;
    cursor: default;
    pointer-events: none;
  `
